import React, {
  // useState, useEffect,
  memo,
} from 'react';
import tw from './CountryFlagIcons/tw.svg';
import hk from './CountryFlagIcons/hk.svg';
import sg from './CountryFlagIcons/sg.svg';
import id from './CountryFlagIcons/id.svg';
import jp from './CountryFlagIcons/jp.svg';
import kr from './CountryFlagIcons/kr.svg';
import ind from './CountryFlagIcons/in.svg';
import us from './CountryFlagIcons/us.svg';
import ca from './CountryFlagIcons/ca.svg';
import br from './CountryFlagIcons/br.svg';
import pl from './CountryFlagIcons/pl.svg';
import it from './CountryFlagIcons/it.svg';
import be from './CountryFlagIcons/be.svg';
import fr from './CountryFlagIcons/fr.svg';
import gb from './CountryFlagIcons/gb.svg';
import de from './CountryFlagIcons/de.svg';
import nl from './CountryFlagIcons/nl.svg';
import ch from './CountryFlagIcons/ch.svg';
import fi from './CountryFlagIcons/fi.svg';
import au from './CountryFlagIcons/au.svg';
import bh from './CountryFlagIcons/bh.svg';
import es from './CountryFlagIcons/es.svg';
import il from './CountryFlagIcons/il.svg';
import za from './CountryFlagIcons/za.svg';
import mx from './CountryFlagIcons/mx.svg';
import sa from './CountryFlagIcons/sa.svg';
import ie from './CountryFlagIcons/ie.svg';
import se from './CountryFlagIcons/se.svg';
import qa from './CountryFlagIcons/qa.svg';
import cl from './CountryFlagIcons/cl.svg';
import global from './CountryFlagIcons/global.svg';
import { isArray } from 'lodash';
const country_flag_icons = {
  // AWS / GCP regions (existing)
  'asia-east1': tw,
  'asia-east1-b': tw,
  'asia-east1-a': tw,
  'asia-east1-c': tw,
  'asia-east2': hk,
  'asia-east2-a': hk,
  'asia-east2-b': hk,
  'asia-east2-c': hk,
  'asia-southeast1': sg,
  asia: sg,
  asia1: sg,
  'asia-southeast1-b': sg,
  'asia-southeast1-a': sg,
  'asia-southeast1-c': sg,
  'asia-southeast2': id,
  'asia-southeast2-a': id,
  'asia-southeast2-b': id,
  'asia-southeast2-c': id,
  'asia-southeast3': id,
  'asia-southeast3-a': id,
  'asia-southeast3-b': id,
  'asia-southeast3-c': id,
  'asia-northeast1': jp,
  'asia-northeast1-b': jp,
  'asia-northeast1-c': jp,
  'asia-northeast1-a': jp,
  'asia-northeast2': jp,
  'asia-northeast2-a': jp,
  'asia-northeast2-b': jp,
  'asia-northeast2-c': jp,
  'asia-northeast3': kr,
  'asia-northeast3-a': kr,
  'asia-northeast3-b': kr,
  'asia-northeast3-c': kr,
  'asia-south1': ind,
  'asia-south2': ind,
  in: ind,
  it: it,
  'asia-south2-a': ind,
  'asia-south2-b': ind,
  'asia-south2-c': ind,
  'asia-south1-a': ind,
  'asia-south1-c': ind,
  'asia-south1-b': ind,
  'us-central1': us,
  'us-west1': us,
  'us-west1-b': us,
  'us-west1-c': us,
  'us-west1-a': us,
  'us-west2': us,
  'us-west2-a': us,
  'us-west2-b': us,
  'us-west2-c': us,
  'us-west3': us,
  'us-west3-a': us,
  'us-west3-b': us,
  'us-west3-c': us,
  'us-west4': us,
  'us-west4-a': us,
  'us-west4-b': us,
  'us-west4-c': us,
  'us-east1': us,
  'us-east1-b': us,
  'us-east1-c': us,
  'us-east1-d': us,
  'us-east4': us,
  'us-east4-c': us,
  'us-east4-b': us,
  'us-east4-a': us,
  'us-east5': us,
  'us-east5-a': us,
  'us-east5-b': us,
  'us-east5-c': us,
  'us-south1': us,
  'us-south1-a': us,
  'us-south1-b': us,
  'us-south1-c': us,
  'us-central-1': us,
  'northamerica-northeast1': ca,
  'northamerica-northeast1-a': ca,
  'northamerica-northeast1-b': ca,
  'northamerica-northeast1-c': ca,
  'northamerica-northeast2': ca,
  'northamerica-northeast2-a': ca,
  'northamerica-northeast2-b': ca,
  'northamerica-northeast2-c': ca,
  'southamerica-east1': br,
  'southamerica-east1-b': br,
  'southamerica-east1-c': br,
  'southamerica-east1-a': br,
  'europe-central2': pl,
  'europe-central2-a': pl,
  'europe-central2-b': pl,
  'europe-central2-c': pl,
  'europe-west1': be,
  'europe-west1-b': be,
  'europe-west1-d': be,
  'europe-west1-c': be,
  eu: fr,
  eur: fr,
  europe: fr,
  eur3: fr,
  eur4: fr,
  eur5: fr,
  eur6: fr,
  eur7: fr,
  eur8: fr,
  'europe-west2': gb,
  'europe-west2-c': gb,
  'europe-west2-b': gb,
  'europe-west2-a': gb,
  'europe-west3': de,
  'europe-west3-c': de,
  'europe-west3-a': de,
  'europe-west3-b': de,
  'europe-west4': nl,
  'europe-west4-a': nl,
  'europe-west4-b': nl,
  'europe-west4-c': nl,
  'europe-west6': ch,
  'europe-west6-a': ch,
  'europe-west6-b': ch,
  'europe-west6-c': ch,
  'europe-north1': fi,
  'europe-north1-a': fi,
  'europe-north1-b': fi,
  'europe-north1-c': fi,
  au: au,
  'australia-southeast1': au,
  'australia-southeast1-b': au,
  'australia-southeast1-c': au,
  'australia-southeast1-a': au,
  'australia-southeast2': au,
  'australia-southeast2-a': au,
  'australia-southeast2-b': au,
  'australia-southeast2-c': au,
  'us-west-1': us,
  us: us,
  'us-west-2': us,
  'us-east-1': us,
  'us-east-2': us,
  'eu-west-1': ie,
  'eu-central-1': de,
  'ap-southeast-1': sg,
  'ap-northeast-1': jp,
  'ap-southeast-2': au,
  'sa-east-1': br,
  'eu-west-2': gb,
  'eu-west-3': fr,
  'ap-south-1': ind,
  'ap-south-2': ind,
  ca: ca,
  de: de,
  'ca-central-1': ca,
  'ap-northeast-2': kr,
  'ap-northeast-3': jp,
  'me-south-1': bh,
  'ap-east-1': hk,
  'af-south-1': za,
  'eu-south-1': it,
  'eu-north-1': se,
  'us-gov-east-1': us,
  'us-gov-west-1': us,
  'ap-southeast-3': id,
  global: global,
  'europe-north2': fi,
  'me-central1': qa,
  'me-central1-a': qa,
  'me-central1-b': qa,
  'me-central1-c': qa,
  'southamerica-west1': cl,
  'southamerica-west1-a': cl,
  'southamerica-west1-b': cl,
  'southamerica-west1-c': cl,
  'us-central1-c': us,
  'us-central1-a': us,
  'me-central2': sa,
  'me-central2-a': sa,
  'me-central2-b': sa,
  'me-central2-c': sa,
  'us-central1-b': us,
  'europe-west10': de,
  'europe-west10-a': de,
  'europe-west10-b': de,
  'europe-west10-c': de,
  'us-central1-f': us,
  'africa-south1': za,
  'africa-south1-a': za,
  'africa-south1-b': za,
  'africa-south1-c': za,
  'northamerica-south1': mx,
  'me-west1': il,
  'me-west1-a': il,
  'me-west1-b': il,
  'me-west1-c': il,
  'europe-west12': it,
  'europe-west12-a': it,
  'europe-west12-b': it,
  'europe-west12-c': it,
  'europe-west9': fr,
  'europe-west9-a': fr,
  'europe-west9-b': fr,
  'europe-west9-c': fr,
  'europe-southwest1': es,
  'europe-southwest1-a': es,
  'europe-southwest1-b': es,
  'europe-southwest1-c': es,
  'europe-west8': it,
  'europe-west8-a': it,
  'europe-west8-b': it,
  'europe-west8-c': it,
  'nam-eur-asia1': us,
  nam10: us,
  nam11: us,
  nam12: us,
  nam3: us,
  nam4: us,
  nam6: us,
  nam7: us,
  nam8: us,
  nam9: us,

  // Azure region mappings
  // United States
  eastus: us,
  eastus2: us,
  southcentralus: us,
  westus2: us,
  westus3: us,
  centralus: us,
  northcentralus: us,
  westus: us,
  westcentralus: us,
  centralusstage: us,
  eastusstage: us,
  eastus2stage: us,
  northcentralusstage: us,
  southcentralusstage: us,
  westusstage: us,
  westus2stage: us,
  unitedstates: us,
  unitedstateseuap: us,
  centraluseuap: us,
  eastus2euap: us,

  // Australia
  australiaeast: au,
  australiasoutheast: au,
  australiacentral: au,
  australiacentral2: au,
  australia: au,

  // Asia-Pacific, East Asia, SE Asia, Taiwan
  southeastasia: sg,
  southeastasiastage: sg,
  eastasia: hk,
  eastasiastage: hk,
  asiapacific: sg,
  taiwannorth: tw,

  // New Zealand
  newzealandnorth: au, // fallback to AU flag due to lack of NZ SVG, swap to NZ if available
  newzealand: au, // fallback, swap if NZ

  // Europe
  northeurope: fi,
  westeurope: fr,
  swedencentral: se,
  sweden: se,
  // europe: fr
  france: fr,
  francecentral: fr,
  francesouth: fr,
  germany: de,
  germanywestcentral: de,
  germanynorth: de,
  germanycentral: de,
  germanynortheast: de,
  italy: it,
  italynorth: it,
  norway: fi,
  norwayeast: fi,
  norwaywest: fi,
  poland: pl,
  polandcentral: pl,
  spaincentral: es,
  switzerland: ch,
  switzerlandnorth: ch,
  switzerlandwest: ch,
  uk: gb,
  uksouth: gb,
  ukwest: gb,
  netherlands: nl, // not in Azure default list but mapped for completeness

  // Canada
  'canada central': ca,
  canadacentral: ca,
  canadaeast: ca,
  canada: ca,

  // Mexico
  mexicocentral: mx,

  // Brazil
  brazilsouth: br,
  brazilsoutheast: br,
  brazil: br,

  // Chile
  chilecentral: cl,

  // Israel
  israelcentral: il,
  israel: il,

  // Qatar & UAE
  qatarcentral: qa,
  qatar: qa,
  uaenorth: qa,
  uaecentral: qa,
  uae: qa,

  // South Africa
  southafricanorth: za,
  southafricawest: za,
  southafrica: za,

  // India
  'central india': ind,

  centralindia: ind,
  southindia: ind,
  westindia: ind,
  jioindiawest: ind,
  jioindiacentral: ind,
  india: ind,

  // Japan
  japaneast: jp,
  japanwest: jp,
  japan: jp,

  // Korea
  koreacentral: kr,
  koreasouth: kr,
  korea: kr,

  // Indonesia
  indonesiacentral: id,
  singapore: sg,

  // Malaysia
  malaysiasouth: sg, // If a MY flag becomes available, change to Malaysia

  // China Mainland
  chinaeast: hk, // fallback using Hong Kong flag
  chinanorth: hk,
  chinaeast2: hk,
  chinanorth2: hk,
  chinaeast3: hk,
  chinanorth3: hk,

  // US Gov
  usgovvirginia: us,
  usgovarizona: us,
  usgovtexas: us,
  usgoviowa: us,
};

// Whether RegionsFlagIcons draws a flag for the region, so callers can show a fallback when it renders nothing.
export const hasRegionFlag = name => Boolean(name && country_flag_icons[name]);

const RegionsFlagIcons = ({ height = '20px', width = '20px', name, isRounded }) => {
  // const [icon, setIcon] = useState(null);
  // useEffect(() => {
  //   setIcon(null);
  //   if (
  //     name === '' ||
  //     name === null ||
  //     name === undefined ||
  //     name === '-' ||
  //     name === 'Unknown' ||
  //     !country_flag_icons[name]
  //   )
  //     return;
  //   async function fetchData() {
  //     try {
  //       const importedIcon = await import(`./CountryFlagIcons/${country_flag_icons[name]}.svg`);
  //       setIcon(importedIcon.default);
  //     } catch (error) {
  //       console.error(`Failed to load flag for ${name}:`, error);
  //       setIcon(null);
  //     }
  //   }
  //   fetchData();
  // }, [name]);

  // console.log(icon, name, 'namekkk');

  if (
    name === '' ||
    name === '-' ||
    name === 'Unknown' ||
    name === null ||
    name === undefined ||
    !country_flag_icons[name]
  )
    return null;

  // console.log(country_flag_icons[name], name'country_flag_icons[name]');
  const nameMap = isArray(name) ? name.map(item => item.split(' ').join('')) : name;

  return (
    <img
      src={country_flag_icons[nameMap]}
      height={height}
      width={width}
      style={isRounded ? { borderRadius: '50%', objectFit: 'cover', width: width, height: height } : undefined}
      alt={`${name} flag`}
    />
  );
};

export default memo(RegionsFlagIcons);
